var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimelapse48Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5952 9.21446C19.8818 7.50834 17.6434 6.65527 15.405 6.65527V15.4046L9.21484 21.5948C12.6344 25.0144 18.1684 25.0144 21.5879 21.5948C25.0075 18.1753 25.0075 12.634 21.5952 9.21446Z",
    fill: "#161C2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.820312 15.4045C0.820312 7.34784 7.34588 0.822266 15.4026 0.822266C23.4593 0.822266 29.9849 7.34784 29.9849 15.4045C29.9849 23.454 23.4593 29.9868 15.4026 29.9868C7.34588 29.9868 0.820312 23.4613 0.820312 15.4045ZM3.73641 15.4042C3.73641 21.8496 8.95687 27.07 15.4022 27.07C21.8476 27.07 27.0681 21.8496 27.0681 15.4042C27.0681 8.95882 21.8476 3.73837 15.4022 3.73837C8.95687 3.73837 3.73641 8.95882 3.73641 15.4042Z",
    fill: "#161C2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimelapse48Px);
export default __webpack_public_path__ + "static/media/ic_timelapse_48px.0eb3662abd3b4dd7acc311f4c6f05cc6.svg";
export { ForwardRef as ReactComponent };